import styled from '@client/styledComponents'

const StackItemContainer = styled.div`
  position: absolute;
`

export { StackItemContainer }
